var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('span',{staticClass:"font-weight-bold text-body-2"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.value),function(person,index){return _c('expandable-person',{key:index,staticClass:"ml-3 mr-5",attrs:{"value":person,"fields":_vm.fields}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }